import React from 'react';

import { observer } from 'mobx-react';

import { asyncNotificationStore } from './store/async-notifications-store';
import TasksAsyncOperationStatus from './tasks-async-operation-status';

const AsyncOperationsNotification: React.FC = () => {
	return (
		<>
			{asyncNotificationStore.operations.map(store => (
				<TasksAsyncOperationStatus key={store.id} store={store} />
			))}
		</>
	);
};

export default observer(AsyncOperationsNotification);
